module.exports = __webpack_public_path__ + "static/media/Bell.41175aa1.svg";